/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_Company_Name_RequiredInputs */

const en_clients_validation_company_name_required = /** @type {(inputs: Clients_Validation_Company_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal name is required.`)
};

const pt_br2_clients_validation_company_name_required = /** @type {(inputs: Clients_Validation_Company_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Razão social é obrigatória.`)
};

/**
* | output |
* | --- |
* | "Legal name is required." |
*
* @param {Clients_Validation_Company_Name_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_company_name_required = /** @type {((inputs?: Clients_Validation_Company_Name_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Company_Name_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_company_name_required(inputs)
	return pt_br2_clients_validation_company_name_required(inputs)
});